import React, { useMemo } from 'react';

import { Progress, rem } from '@vimeo/bokeh';

interface Props {
  passwordScore?: number;
}

export function PasswordStrengthIndicator({ passwordScore }: Props) {
  return useMemo(() => {
    if (passwordScore === undefined) return <></>;

    let progressValue = 25;
    let backgroundColor =
      'linear-gradient(90deg, #9D2926 0%, #E9394C 61.06%, #E0295B 85.1%, #E4259E 100%)';

    if (passwordScore >= 4) {
      progressValue = 95;
      backgroundColor =
        'linear-gradient(90deg, #176127 0%, #127A28 22.12%, #28BF47 44.71%, #13F060 97.12%, #00DDDC 100%)';
    } else if (passwordScore >= 2) {
      progressValue = 50;
      backgroundColor =
        'linear-gradient(90deg, #B06820 16.35%, #D7970B 34.13%, #FED94C 59.13%, #FFC964 86.06%, #FFFF00 100%)';
    }

    return (
      <Progress
        height={rem(4)}
        value={progressValue}
        sx={{
          div: {
            background: backgroundColor,
          },
        }}
      />
    );
  }, [passwordScore]);
}
